import { render, staticRenderFns } from "./CustomerMenu.vue?vue&type=template&id=da2ab5e6&scoped=true&"
import script from "./CustomerMenu.vue?vue&type=script&lang=js&"
export * from "./CustomerMenu.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMenu.vue?vue&type=style&index=0&id=da2ab5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2ab5e6",
  null
  
)

export default component.exports